import React, { Fragment, useState,useEffect} from 'react';
import { withTranslation } from 'react-i18next';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import LaunchIcon from '@material-ui/icons/Launch';

const AdvancedSearchListEventsActions = ({ data,setDataEvent }) => {

    useEffect(() => {
      
    },[])

  return (<Fragment>
      <Tooltip title="Ver Cita">
        <IconButton aria-label="unable" style={{ padding: 2 }}
          onClick={() => {
            setDataEvent(data.data.original);
          }}>
          <LaunchIcon style={{ color: '#000' }}   />
        </IconButton>
      </Tooltip>
  </Fragment>)
}

export default AdvancedSearchListEventsActions;